import { M_Button, M_CheckBox, M_Header } from "../../../M_Components";
import { useTranslation } from "react-i18next";

export const GridFields = ({ fields, hiddenFields, setHiddenFieldCallback, onClose }) => {
    const [t, i18n] = useTranslation();
    const currentLanguage = i18n.resolvedLanguage;

    const handleFieldToggle = (fieldCode, isChecked) => {
        if (isChecked) {
            setHiddenFieldCallback(hiddenFields.filter(f => f !== fieldCode));
        } else {
            setHiddenFieldCallback([...hiddenFields, fieldCode]);
        }
    };

    const handleShowAll = () => {
        setHiddenFieldCallback([]);
    };

    const handleHideAll = () => {
        setHiddenFieldCallback(fields.map(f => f.Code));
    };

    const handleSave = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <div className="filters-grid">
            <div className="filters-header">
                <M_Header
                    color={'var(--color-white)'}
                    element={
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: "10px", width: "100%", alignItems: 'center' }}>
                            <div className="text-title" style={{ marginRight: "auto" }}>
                                {t("NgeFields")}
                            </div>
                            <div style={{ display: "flex" }}>
                                <M_Button
                                    tooltip={t("NgeShowAll")}
                                    label={t("NgeShowAll")}
                                    icon={<i className='pi pi-eye'></i>}
                                    onClick={handleShowAll}
                                />
                                <M_Button
                                    tooltip={t("NgeHideAll")}
                                    label={t("NgeHideAll")}
                                    icon={<i className='pi pi-eye-slash'></i>}
                                    onClick={handleHideAll}
                                />
                                <M_Button
                                    tooltip={t("NgeSave")}
                                    label={t("NgeSave")}
                                    icon={<i className='pi pi-check'></i>}
                                    onClick={handleSave}
                                />
                            </div>
                        </div>
                    }
                />
            </div>
            <div className="filters-form">
                {fields?.map((field) => {
                    const isVisible = !hiddenFields.includes(field.Code);
                    const fieldLabel = field.Captions?.[currentLanguage]?.length > 0
                        ? field.Captions[currentLanguage]
                        : field.Code;

                    return (
                        <div key={field.Code} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center' }}>
                            <M_CheckBox
                                checked={isVisible}
                                onChange={(e) => handleFieldToggle(field.Code, e.target.checked)}
                            />
                            <span style={{ marginLeft: '8px' }} className="text">
                                {fieldLabel}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
